import Vue from 'vue'
import Router from 'vue-router'
import AuthService from '@/services/auth.service'
import Reporting from '@/views/Reporting.vue'
import Predmeti from '@/views/Predmeti.vue'
import PredmetCreate from '@/views/PredmetCreate.vue'
import PredmetView from '@/views/PredmetView.vue'
import Main from '@/views/Main.vue'
import Auth from '@/views/Auth.vue'
import NotFound from '@/views/NotFound.vue'
import Admin from '@/views/Admin.vue'
import Dashboard from '@/views/Dashboard.vue'
import { isAdmin, canViewReports } from '@/models/admin'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/', component: Main, children: [
        { path: '', component: Dashboard },
        { path: '/predmeti', component: Predmeti },
        { path: '/predmet/create', component: PredmetCreate },
        { path: '/predmet/view/:id', component: PredmetView },
        { path: 'reports', component: Reporting, meta: { reportsOnly: true } },
        { path: 'admin', component: Admin, meta: { adminOnly: true } },
      ]
    },
    { path: '/login', component: Auth },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        AuthService.logout()
        next('/login')
      }
    },
    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' }
  ]
})


router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/about', '/404'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = AuthService.isLoggedIn();

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else if (to.matched.some((r) => r.meta && r.meta.reportsOnly) && !canViewReports()) {
    next('/');
  } else if (to.matched.some((r) => r.meta && r.meta.adminOnly) && !isAdmin()) {
    // Admin area is for one account; anyone else is sent back to the list.
    next('/');
  } else {
    next();
  }
});